module.exports = __webpack_public_path__ + "static/radio_hour_logo-fda3874d506eb752313c2f50de74db58.png";